"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthConnector = void 0;
const EthConnectorLogic_1 = __importDefault(require("../../abis/teleswap/EthConnectorLogic"));
const contract_base_1 = __importDefault(require("../contract-base"));
class EthConnector extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, EthConnectorLogic_1.default);
    }
    swapAndUnwrap(exchangeInfo, receiverBitcoinScript, addressTypeNumber, lockerLockingScript, thirdPartyId = 0, relayerFeePercentage) {
        const { value, params } = EthConnector.swapAndUnwrapParams(exchangeInfo, receiverBitcoinScript, addressTypeNumber, lockerLockingScript, thirdPartyId, relayerFeePercentage);
        return this.contractSendMethodNoError("swapAndUnwrap", value, params);
    }
    static swapAndUnwrapParams(exchangeInfo, receiverBitcoinScript, addressTypeNumber, lockerLockingScript, thirdPartyId = 0, relayerFeePercentage) {
        const value = exchangeInfo.isNativeToken || false ? exchangeInfo.inputAmount.toString() : "0";
        const params = [
            exchangeInfo.ethTokenAddress,
            exchangeInfo.exchangeConnector,
            [exchangeInfo.inputAmount, exchangeInfo.outputAmount],
            exchangeInfo.isFixedToken,
            exchangeInfo.destinationPath,
            [receiverBitcoinScript, addressTypeNumber, lockerLockingScript],
            relayerFeePercentage,
            thirdPartyId,
        ];
        return {
            params,
            value,
        };
    }
}
exports.EthConnector = EthConnector;
exports.default = EthConnector;
//# sourceMappingURL=eth-connector-contract-interface.js.map